import { render, staticRenderFns } from "./Acquisitions.vue?vue&type=template&id=24781bd6&scoped=true&"
import script from "./Acquisitions.vue?vue&type=script&lang=js&"
export * from "./Acquisitions.vue?vue&type=script&lang=js&"
import style0 from "./Acquisitions.vue?vue&type=style&index=0&id=24781bd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24781bd6",
  null
  
)

export default component.exports